import BootcampInstanceSection from '../api/bootcampInstanceSection';
import { applicationSave, applicationFetch, applicationUpdate, applicationFetchAll } from './applicationActions';

export const saveBootcampInstanceSection = applicationSave(BootcampInstanceSection);
export const fetchBootcampInstanceSection = applicationFetch(BootcampInstanceSection);
export const updateBootcampInstanceSection = applicationUpdate(BootcampInstanceSection);
export const fetchBootcampInstanceSections = applicationFetchAll(BootcampInstanceSection);
